var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag has-text-weight-medium",class:{
      'is-primary': _vm.display == 'new' || _vm.display == 'active' || _vm.display == 'fulfilled',
      'is-warning': _vm.display == 'processing',
      'is-danger': _vm.display == 'declined' || _vm.display == 'shipping-expired' || _vm.display == 'acceptance-expired',
      'is-light is-info': _vm.display == 'proposal' || _vm.display == 'draft'  || _vm.display == 'disabled'
  }},[_vm._v(_vm._s(_vm.status))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32738c1b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/StatusTag.vue
// module id = null
// module chunks = 